import React from 'react';
import { Alert, Empty, Spin, Tag, Typography } from 'antd';
import { useMeasurementReport } from './measurementReport/MeasurementReportContext';
import { MeasurementSectionShell, buildMeasurementSectionMeta } from './measurementReport/MeasurementSectionShell';

const { Text } = Typography;

interface CommonSectionProps {
    section: any;
}

export const ReportMeasurementValues: React.FC<CommonSectionProps> = ({ section }) => {
    const { measurementId, measurement, loading, error } = useMeasurementReport();
    const sectionTitle = section?.title || 'Values';
    const sectionMeta = buildMeasurementSectionMeta(measurement);

    if (!measurementId) {
        return (
            <MeasurementSectionShell title={sectionTitle}>
                <Alert message="Select a measurement to view values." type="info" showIcon />
            </MeasurementSectionShell>
        );
    }

    if (loading) {
        return (
            <MeasurementSectionShell title={sectionTitle} meta={sectionMeta}>
                <div className="report-measurement-panel-state">
                    <Spin tip="Loading values..." />
                </div>
            </MeasurementSectionShell>
        );
    }

    if (error || !measurement) {
        return (
            <MeasurementSectionShell title={sectionTitle} meta={sectionMeta}>
                <Alert message={error || 'Measurement not found'} type="error" showIcon />
            </MeasurementSectionShell>
        );
    }

    const values = measurement.values || [];

    if (values.length === 0) {
        return (
            <MeasurementSectionShell title={sectionTitle} meta={sectionMeta}>
                <div className="report-measurement-panel-state">
                    <Empty description="No measurement values" image={Empty.PRESENTED_IMAGE_SIMPLE} />
                </div>
            </MeasurementSectionShell>
        );
    }

    return (
        <MeasurementSectionShell
            title={sectionTitle}
            meta={sectionMeta}
            toolbar={
                <div className="report-measurement-summary">
                    <span className="report-measurement-pill">{values.length} values</span>
                </div>
            }
        >
            <div className="report-measurement-values-list">
                {values.map((value: any) => (
                    <div key={value.id || value.valueType} className="report-measurement-values-row">
                        <div className="report-measurement-values-key">
                            <span className="report-measurement-values-label">{value.valueType}</span>
                            {value.processingStage ? (
                                <Tag className="report-measurement-values-stage">{value.processingStage}</Tag>
                            ) : null}
                        </div>
                        <div className="report-measurement-values-value">
                            <Text code>{value.textValue ?? value.numValue ?? '—'}</Text>
                        </div>
                    </div>
                ))}
            </div>
        </MeasurementSectionShell>
    );
};

export default ReportMeasurementValues;
